import { NgModule } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { CommonModule } from '@angular/common'
import { DeployBannerComponent } from './deploy-banner.component'

@NgModule({
  declarations: [DeployBannerComponent],
  exports: [DeployBannerComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule],
})
export class DeployBannerModule {}
